import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import {getDefaultI18nLanguage } from "./utils";

const defaultLng = getDefaultI18nLanguage ();

i18n
    .use(initReactI18next)
    .use(HttpApi)
    .init({
        lng: defaultLng,
        fallbackLng: "en",

        keySeparator: false, // we do not use keys
        // keySeparator: '.', // the key to access nested keys

        interpolation: {
            escapeValue: false, // react already safes us from xss
            prefix: "{",
            suffix: "}"
        },

        // i18next-http-backend options
        backend: {
            loadPath: '/locales/{lng}/translation.json',
        },
    });

export default i18n;